import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSource',
})
export class FilterSourcePipe implements PipeTransform {
  transform(
    productType: string | null,
    sourceItems: { id: string; displayValue: string }[],
    strictTo?: string
  ): { id: string; displayValue: string }[] {
    if (strictTo?.trim().length) {
      return sourceItems.filter((obj) => obj.id === strictTo);
    }

    if (productType === 'CLN') {
      return sourceItems.filter((obj) => obj.id.indexOf('fvc') === -1);
    }
    return sourceItems.filter((obj) => obj.id.startsWith('fvc'));
  }
}
